import React, { useEffect, useState } from 'react';
import { Drawer, Box, IconButton, Menu, MenuItem } from '@material-ui/core/';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PeopleIcon from '@material-ui/icons/People';
import AccountCircle from '@material-ui/icons/AccountCircle';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import HomeIcon from '@material-ui/icons/Home';
import AssignmentIndOutlinedIcon from '@material-ui/icons/AssignmentIndOutlined';
import MessageIcon from '@material-ui/icons/Message';
import BusinessIcon from '@material-ui/icons/Business';
import useStyles from "./Layout.style";
import { Link, withRouter } from 'react-router-dom';
import Cookies from 'universal-cookie';


const cookies = new Cookies();

const Layout = props => {
    const classes = useStyles();

    const [anchorEl, setAnchorEl] = useState(null);
    const [user, setUser] = useState();

    useEffect(() => {
        const getUser = async () => {
            let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER_AUTH_SIGNEDUSER}`, {
                headers: {
                    'X-ACCESS-TOKEN': cookies.get('token')
                }
            });
            let user = await response.json();

            setUser(user);
        };

        getUser();
    }, []);

    const open = Boolean(anchorEl);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = async () => {
        try {
            await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER_AUTH_SIGNOUT}`);
            localStorage.clear();
            localStorage.setItem('provider-logout-event', 'logout' + Math.random());
            cookies.remove('token', { path: '/' });
            props.history.push('/provider/login');
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <Box className={classes.root}>
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <Typography className={classes.title}>
                        RepLI for Provider
                    </Typography>
                    <Typography>
                        Hi {user && user.firstName}
                    </Typography>
                    <IconButton
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenu}
                        color="inherit"
                    >
                        <AccountCircle />
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={open}
                        onClose={handleClose}>
                        <MenuItem onClick={handleClose} component={Link} to="/provider/myaccount">My account</MenuItem>
                        <MenuItem onClick={handleLogout}>Logout</MenuItem>
                    </Menu>
                </Toolbar>
            </AppBar>
            <Drawer
                className={classes.drawer}
                variant="permanent"
                classes={{
                    paper: classes.drawerPaper,
                }}
                anchor="left"
            >
                <div className={classes.toolbar} />
                <Divider />
                <List>
                    <ListItem button component={Link} to="/provider">
                        <ListItemIcon><HomeIcon /></ListItemIcon>
                        <ListItemText primary="Home" />
                    </ListItem>
                    {user && user.roles && user.roles.includes('provider') &&
                        <ListItem button component={Link} to="/provider/provider/mypatients">
                            <ListItemIcon><LocalHospitalIcon /></ListItemIcon>
                            <ListItemText primary="My Patients" />
                        </ListItem>
                    }
                    {user && user.roles && user.roles.includes('administrator') &&
                        <ListItem button component={Link} to="/provider/message">
                            <ListItemIcon><MessageIcon /></ListItemIcon>
                            <ListItemText primary="Messaging" />
                        </ListItem>
                    }
                    {user && user.roles && user.roles.includes('administrator') &&
                        <ListItem button component={Link} to="/provider/provider">
                            <ListItemIcon><AssignmentIndOutlinedIcon /></ListItemIcon>
                            <ListItemText primary="Providers" />
                        </ListItem>
                    }
                    {user && user.roles && user.roles.includes('administrator') &&
                        <ListItem button component={Link} to="/provider/user">
                            <ListItemIcon><PeopleIcon /></ListItemIcon>
                            <ListItemText primary="Users" />
                        </ListItem>
                    }
                    {user && user.roles && user.roles.includes('administrator') &&
                        <ListItem button component={Link} to="/provider/organizations">
                            <ListItemIcon><BusinessIcon /></ListItemIcon>
                            <ListItemText primary="Organizations" />
                        </ListItem>
                    }
                </List>
            </Drawer>
            <Box className={classes.content}>
                <Box className={classes.toolbar} />
                <Box className={classes.children}>
                    {props.children}
                </Box>
            </Box>
        </Box >
    );
};

export default withRouter(Layout);
